import styled from 'styled-components';
import {
  DESKTOP_MIN_BREAK,
  DETAIL_HEADER_HEIGHT,
  Z_INDEX_SECOND_TOP,
  NAV_HEIGHT,
  SYSTEM_ALERT_BANNER_HEIGHT,
  MOBILE_MAX_BREAK,
  TOP_BORDER_RADIUS,
  NAV_OFFSET_DETAIL_VIEW,
} from '#/shared/constants';

export const DetailViewWrapper = styled.div`
  box-shadow: none;
  display: flex;
  flex-direction: column;
  @media (max-width: ${MOBILE_MAX_BREAK}) {
    flex: 1;
  }

  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    // 50px is offset between bottom of nav bar and top detail container
    height: calc(
      100vh - 50px - ${NAV_OFFSET_DETAIL_VIEW} -
        ${({ alertBannerIsVisible }) =>
          alertBannerIsVisible ? SYSTEM_ALERT_BANNER_HEIGHT : '0px'}
    );
    border-radius: ${TOP_BORDER_RADIUS};
  }
`;

export const DetailViewTop = styled.div`
  display: flex;
  width: 100%;
  height: ${DETAIL_HEADER_HEIGHT};
  z-index: ${Z_INDEX_SECOND_TOP};

  /* on mobile the detail-view-top is above the map, covering the nav bar so it
  is taken out of the flow of its container fixed to the top of the viewport */
  @media (max-width: ${MOBILE_MAX_BREAK}) {
    position: fixed;
    top: 0;
  }
`;

export const DetailViewMiddle = styled.div`
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    flex: 0 0 auto;
  }
`;

export const DetailViewBottom = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: ${props => (props.hideMapOnMobile ? NAV_HEIGHT : 0)};
  min-height: 400px;
  background-color: ${props =>
    props.hasInverseBackground
      ? props.theme.inverseBackgroundColor2
      : props.theme.backgroundColor};

  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    flex: 1 1 auto;
    margin-top: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;
